export default 'https://tme.understood.org/assets/narnia_door_2.1219f296.glb'